Revolution.Module.extend({
    NAME: "mde.tables", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/compatibility.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "equalheight", "runEqualHeight", "getHeightsForOffsets");

        //events

        this.setStickyTr();
    },

    onWindowLoad: function (e) {
        this.setStickyTr();
    },

    onWindowScroll: function (e) {
        this.setStickyTr();
    },
    onWindowResize: function (e) {
        this.setStickyTr();
    },

    setStickyTr: function () {
        $('.js-elem-sticky').each(function (index, elem) {

            var headerH = $('.page-header-wrapper').outerHeight();
            if (!$(elem).prev().hasClass('js-offset')) {
                $('<div class="js-offset" data-w="'+$(elem).width()+'" data-height="'+$(elem).height()+'"></div>').insertBefore($(elem));

                $(elem).find('th, td').each(function(index, elem) {
                    $(elem).data('w', $(elem).outerWidth());
                });
            }

            var offsetT = $(elem).prev().offset().top;
            var wScrollTop = $(window).scrollTop();
            var distanceT = wScrollTop - (offsetT - headerH);
            var endOfStick = $(elem).data('end-stick');
            var endOfStickOffsetB = $(endOfStick).last().offset().top + $(endOfStick).last().height();
            var distanceB = wScrollTop - (endOfStickOffsetB - headerH - $(elem).outerHeight());
            var distanceBetweenoffsets = endOfStickOffsetB - offsetT;


            // console.log('offsetT : ', offsetT);
            // console.log('wScrollTop : ', wScrollTop);
            // console.log('headerH : ', headerH);
            // console.log('distanceT : ', distanceT);
            // console.log('endOfStickOffsetB : ', endOfStickOffsetB);
            // console.log('distanceB : ', distanceB);

            if (distanceT >= 0 && distanceB <=0) {
                $(elem).css({'position':'fixed', 'top': headerH+'px', 'transform': '', 'width': $(elem).prev().data('w')+'px'}).addClass('is-stuck');
                $(elem).prev().css('height', $(elem).height());

                $(elem).find('th, td').each(function(index, elem) {
                    $(elem).css('width', $(elem).data('w'));
                });
            } else if (distanceT < 0) {
                $(elem).css({'position': '', 'top': '', 'width': ''}).removeClass('is-stuck');
                $(elem).prev().css('height', '');

                $(elem).find('th, td').each(function(index, elem) {
                    $(elem).css('width', '');
                });
            } else if (distanceB >=0) {
                $(elem).css({'transform': 'translateY('+(distanceBetweenoffsets - $(elem).outerHeight())+'px)', 'position': 'relative', 'top': '', 'width': ''}).removeClass('is-stuck');
                $(elem).prev().css('height', '');

                $(elem).find('th, td').each(function(index, elem) {
                    $(elem).css('width', '');
                });
            }
        });
    }

});
